import React from 'react';
import { Globe } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

/**
 * Compact EN / ES toggle that fits inline in the navbar. Active language is
 * highlighted in gold; tapping the inactive code swaps the site language.
 */
const LanguageSwitch = ({ className = '', size = 'sm' }) => {
  const { lang, setLang, t } = useLang();
  const codes = [
    { code: 'en', label: 'EN', fullName: t('lang.english') },
    { code: 'es', label: 'ES', fullName: t('lang.spanish') },
  ];

  return (
    <div
      className={`inline-flex items-center gap-1.5 ${className}`}
      role="group"
      aria-label="Language"
      data-testid="language-switch"
    >
      <Globe
        size={size === 'sm' ? 14 : 16}
        className="text-white/55"
        aria-hidden="true"
      />
      <div className="inline-flex items-center rounded-full border border-white/15 bg-black/40 px-1 py-0.5">
        {codes.map((c, i) => {
          const active = lang === c.code;
          return (
            <button
              key={c.code}
              type="button"
              onClick={() => setLang(c.code)}
              data-testid={`lang-${c.code}`}
              aria-pressed={active}
              aria-label={t('lang.switch_to', { lang: c.fullName })}
              className={`font-nav text-[10px] tracking-widest px-2 py-1 rounded-full transition-colors ${
                active
                  ? 'bg-[#f5b400] text-black'
                  : 'text-white/65 hover:text-white'
              } ${i === 0 ? '' : 'ml-0.5'}`}
            >
              {c.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default LanguageSwitch;
